import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const RibSchema = z.object({
  beneficiary: z
    .string({ required_error: i18nMessage("boParameters:ribForm.beneficiaryRequired") })
    .min(1, { message: i18nMessage("boParameters:ribForm.beneficiaryRequired") }),
  iban: z
    .string({ required_error: i18nMessage("boParameters:ribForm.ibanRequired") })
    .min(1, { message: i18nMessage("boParameters:ribForm.ibanRequired") }),
  bic: z
    .string({ required_error: i18nMessage("boParameters:ribForm.bicRequired") })
    .min(1, { message: i18nMessage("boParameters:ribForm.bicRequired") }),
  bankName: z
    .string({ required_error: i18nMessage("boParameters:ribForm.bankNameRequired") })
    .min(1, { message: i18nMessage("boParameters:ribForm.bankNameRequired") }),
  bankAddress: z
    .string({ required_error: i18nMessage("boParameters:ribForm.bankAddressRequired") })
    .min(1, { message: i18nMessage("boParameters:ribForm.bankAddressRequired") }),
  shortenName: z
    .string({ required_error: i18nMessage("boParameters:ribForm.shortenNameRequired") })
    .min(1, { message: i18nMessage("boParameters:ribForm.shortenNameRequired") })
    .max(3, { message: i18nMessage("boParameters:ribForm.shortenNameMax") }),
  isDefault: z.boolean().default(false),
});

export type RibFormData = z.infer<typeof RibSchema>;

export const CreateRibSchema = RibSchema.omit({ isDefault: true });

export type CreateRibFormData = z.infer<typeof CreateRibSchema>;
